import { s3UrlCoinImage } from 'store/constant';

export const getCoinImageUrl = (symbol: string) => {
    return `${s3UrlCoinImage}/${symbol}.png`;
};
